/**
 * @generated SignedSource<<296a26ba12532fe922a7008662cde02b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StarButtonFolderCardStarFragment$data = {
  readonly viewer: {
    readonly favoritedSummary: {
      readonly isFavorite: boolean;
    } | null;
  } | null;
  readonly " $fragmentType": "StarButtonFolderCardStarFragment";
};
export type StarButtonFolderCardStarFragment$key = {
  readonly " $data"?: StarButtonFolderCardStarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StarButtonFolderCardStarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StarButtonFolderCardStarFragment",
  "selections": [
    {
      "concreteType": "ConfluenceContentViewerSummary",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConfluenceFavoritedSummary",
          "kind": "LinkedField",
          "name": "favoritedSummary",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isFavorite"
            }
          ]
        }
      ]
    }
  ],
  "type": "ConfluenceFolder"
};

(node as any).hash = "62017b9252e425c5ce11b9dacbcfcca3";

export default node;
